export type PublicationPaginationRuleModel = {
  cache_key: number,
  id: number,
  publication_id: number,
  pagination_rule_id: number,
}

export type PublicationPaginationRuleRequestOptions = {
  include_publication_pagination_rule_publication?: boolean,
  include_publication_pagination_rule_pagination_rule?: boolean,
  include_pagination_rule_brand?: boolean,
}

const state = {
  id: null,
  publication_id: undefined,
  pagination_rule_id: undefined,
}

export const requiredFields = [
  { key: 'publication_id' },
  { key: 'pagination_rule_id' },
]

export default state
